import { connect } from "react-redux";
import MatchControls from "./MatchControls";
import { handleChangeTrendMatchMode } from "../../../../../../../../../../redux/actions";
import { MATCH_MODE_KEEP_ROWS } from "../../../../constants";

// The match mode lives in redux so it survives the comparison toggle; the
// search box stays with ComparisonView, which fetches both lists from it.
const mapStateToProps = (state) => ({
    matchMode: state.BenchmarkFilteringReducer.trendPairing.matchMode,
});

const mapDispatchToProps = (dispatch) => ({
    onChangeMatchMode: (value) => dispatch(handleChangeTrendMatchMode({ value, keepRows: MATCH_MODE_KEEP_ROWS })),
});

export default connect(mapStateToProps, mapDispatchToProps)(MatchControls);
